<template>
	<div ref="tablePage" style="height: 100%">
		<!-- 面包屑导航 -->
		<div class="topNav">
			<div class="navFormWrapper">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>客户评分规则列表</el-breadcrumb-item>
				</el-breadcrumb>
				<el-button type="success" style="margin-left: 8vh" icon="el-icon-plus" @click="handleNewAdd"
					size="mini">新增评分规则</el-button>
			</div>
		</div>
		<el-table :data="tableList" style="width: 100%; margin-top: 2vh" border size="mini" :header-cell-style="{
        background: '#fff',
        height: '50px',
        color: '#909399',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif'}">
			<el-table-column prop="id" label="ID" align="center" />
			<el-table-column prop="rule_name" label="规则名称" align="center" />
			<el-table-column prop="version" label="版本" align="center">
			</el-table-column>
			<el-table-column prop="create_time" label="创建时间" align="center">
			</el-table-column>
			<el-table-column prop="update_time" label="更新时间" align="center" />
			<el-table-column fixed="right" label="操作" align="center" width="260">
				<template slot-scope="scope">
					<el-button @click.native.prevent="handleClick(scope.row)" type="primary" size="small"
						icon="el-icon-edit">
						修改
					</el-button>
					<!-- <el-button @click.native.prevent="singleDel(scope.row, scope.row.id)" type="danger" size="small"
						icon="el-icon-delete">
						移除
					</el-button> -->
				</template>
			</el-table-column>
		</el-table>
		<pagination v-show="total > 0" :total="total" :page.sync="searchForm.page" :limit.sync="searchForm.pageSize"
			@pagination="initList" />
		<el-dialog :title="title" :visible.sync="addOrEditOpen" :close-on-click-modal="false" width="65%"
			 :before-close="getout"
			:append-to-body="true" top="5vh">
			<el-table ref="form" :data="tableData" :span-method="objectSpanMethod" @cell-click="handleCellClick" border
				style="width: 100%;" :max-height="dmaxHeight">
				<el-table-column prop="ruleName" label="维度" width="180">
				</el-table-column>
				<el-table-column prop="score" label="分值" align="center">
				</el-table-column>
				<el-table-column prop="sruleName" label="标签组">
				</el-table-column>
				<el-table-column prop="sscore" label="比例" align="center">
				</el-table-column>
				<el-table-column prop="ssruleName" label="子标签">
				</el-table-column>
				<el-table-column prop="ssscore" label="权重" align="center">
				</el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForms">确 定</el-button>
				<el-button @click="getout">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		Row
	} from "element-ui";
	import tableCommon from "../../../mixins/table-common";
	import {
		getCustomerRuleList,
		getCustomerRuleDetail,
		getCustomerRuleDefault,
		addCustomerRule,
		editCustomerRule
	} from "../../api/customerRule";

	export default {
		mixins: [tableCommon],
		data() {
			return {
				// 请求地址api
				api: {
					list: getCustomerRuleList,
					add: addCustomerRule,
					edit: editCustomerRule
				},
				// 弹窗标题
				title: "新增",
				addOrEditOpen: false,
				dmaxHeight: 0,
				showEdit: [],
				tableData: [],
				rowcolSpans: [],
				templateData: null,
				form: null,
				totalScore: 0,
			};
		},
		mounted() {
			this.dmaxHeight = window.innerHeight * 0.70;
			getCustomerRuleDefault().then((res) => {
				this.templateData = res.data;
			});
		},
		methods: {
			objectSpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				let rowspan = this.rowcolSpans[columnIndex][rowIndex];
				let colspan = rowspan > 0 ? 1 : 0;

				return {
					rowspan: rowspan,
					colspan: colspan
				};
			},
			handleCellClick(row, col, cell, event) {
				let that = this;
				if (event.target.innerText.length > 0 && (col.label == '分值' || col.label == '比例' || col.label == '权重')) {
					event.target.innerText = "";
					let cellInput = document.createElement("input");
					cellInput.value = row[col.property];
					cellInput.setAttribute("type", "decimal");
					cellInput.style.width = "70%";
					cellInput.style.height = "20px";
					cellInput.style.marginLeft = "10px";
					cellInput.style.paddingLeft = "5px";
					cell.appendChild(cellInput);
					// 聚焦
					cellInput.focus();
					// 失焦事件
					cellInput.onblur = function() {
						if (cellInput.value.trim().length == 0) {
							that.$message.warning('请输入',col.label);
							cellInput.focus();
							return;
						}
						let reg = col.label == '比例' || col.label == '权重' ? /^[0-9]+(.[0-9]{1,2})?$/ : /^([0-9]*)$/
						let input = reg.test(cellInput.value);
						// console.log('======================input :',input)
						if (!input) {
							that.$message.warning('请输入正确数值');
							cellInput.focus();
							return;
						}
						
						if ((col.label == '比例' || col.label == '权重') && cellInput.value > 1) {
							that.$message.warning('请输入小于等于1的数');
							cellInput.focus();
							return;
						}
						cell.removeChild(cellInput);
						event.target.innerText = cellInput.value;
						row[col.property] = cellInput.value;
						// console.log('====================:',that.tableData)
					};
				}
				
			},
			// 新增弹窗
			handleNewAdd() {
				if (!this.templateData) {
					this.$message.warning('模版加载未完成，请稍后重试');
					return;
				}
				this.title = "新增";
				this.handleAdd();
				this.handleData(this.templateData);
			},
			// 修改弹窗
			handleClick(row) {
				this.title = "修改";
				this.handleEdit();
				getCustomerRuleDetail({id:row.id}).then(res=>{
					if (res.data) {
						this.handleData(res.data);
					}
				})
			},
			// 点击确定
			submitForms() {
				var d_id = -1,sub_id = -1;
				var total_score = 0,sub_score_rato = 0;
				var rato_tips = '';
				this.tableData.forEach((item,index) => {
					if (item.id != d_id) {
						total_score = total_score + parseInt(item.score);
						if (sub_score_rato != 0 && (sub_score_rato > 1 || sub_score_rato < 1)) {
							rato_tips += this.tableData[index-1].ruleName + '比例值之和不为1;';
						}
						sub_score_rato = 0;
					}
					if (sub_id != item.sid) {
						sub_score_rato += parseFloat(item.sscore);
					}
					
					d_id = item.id;
					sub_id = item.sid;
					console.log('=====================rato:',total_score,sub_score_rato)
				});
				if (total_score == this.form.score && rato_tips.length == 0) {
					
					this.form.sub_configs.forEach((item,index) => {
						var itemScoreNewValue = this.tableData.find((titem,index) => titem.id == item.id).score;
						var alter = itemScoreNewValue == item.score ? 0 : 1;
						item.score = itemScoreNewValue;
						if (this.actionType === 'edit') {
							item.alter = alter;
						}
						
						item.sub_configs.forEach((sitem, sindex) => {
							var sitemScoreNewValue = this.tableData.find((titem,index) => titem.sid == sitem.id).sscore;
							var salter = sitemScoreNewValue == sitem.score_ratio ? 0 : 1;
							sitem.score_ratio = sitemScoreNewValue;
							if (this.actionType === 'edit') {
								sitem.alter = salter;
							}
							
							sitem.sub_configs.forEach((ssitem, ssindex) => { 
								var ssitemScoreNewValue = this.tableData.find((titem,index) => titem.ssid == ssitem.id).ssscore;
								var ssalter = ssitemScoreNewValue == ssitem.weight ? 0 : 1;
								ssitem.weight = ssitemScoreNewValue;
								if (this.actionType === 'edit') {
									ssitem.alter = ssalter;
								}
							})
						})
					});
					console.log('=======================数据提交：', this.form);
					this.btnLoading = true
					if (this.actionType === 'edit') {
					    let fn = this.api.edit
					    fn(this.form).then((response) => {
					        this.addOrEditOpen = false
					        this.btnLoading = false
					        this.$message.success('修改成功')
					        this.initList()
					    })
					} else if (this.actionType === 'add') {
					    let fn = this.api.add
					    fn(this.form).then((response) => {
					        this.addOrEditOpen = false
					        this.btnLoading = false
					        this.$message.success('添加成功');
					        this.initList()
					    })
					}
				}else{
					this.$message.warning('分值总分不为：' + this.form.score + (rato_tips.length ? ';' + rato_tips : ''))
				}
			},
			// 处理新增和编辑数据
			handleData(data) {
				setTimeout(() => {
					var tableData = [];
				
					var rows0 = [],
						rows1 = [],
						rows2 = [];
					this.form = data;
					// console.log('=======================数据：', this.form);
					data.sub_configs.forEach((item, index) => {
						var row = 0;
						item.sub_configs.forEach((sitem, sindex) => {
							sitem.sub_configs.forEach((ssitem, ssindex) => {
								var tableItem = {}
								tableItem.id = item.id;
								tableItem.ruleName = item.rule_name;
								tableItem.score = item.score;
				
								row++;
				
								tableItem.sid = sitem.id;
								tableItem.sruleName = sitem.rule_name;
								tableItem.sscore = sitem.score_ratio;
				
								tableItem.ssid = ssitem.id;
								tableItem.ssruleName = ssitem.rule_name;
								tableItem.ssscore = ssitem.weight;
				
								rows2.push(1);
				
								tableData.push(tableItem);
							})
							rows1.push(sitem.sub_configs.length);
						})
				
						rows0.push(row);
					})
				
					var row_0 = [];
					for (var i = 0; i < rows0.length; i++) {
						for (var j = 0; j < rows0[i]; j++) {
							if (j == 0) {
								row_0.push(rows0[i]);
							} else {
								row_0.push(0);
							}
						}
					}
				
					var row_1 = [];
					for (var i = 0; i < rows1.length; i++) {
						for (var j = 0; j < rows1[i]; j++) {
							if (j == 0) {
								row_1.push(rows1[i]);
							} else {
								row_1.push(0);
							}
						}
					}
				
					this.rowcolSpans = [row_0, row_0, row_1, row_1, rows2, rows2];
					this.tableData = tableData;
				});
			},
			// 关闭弹窗
			getout() {
				this.addOrEditOpen = false;
			},
		},
	};
</script>

<style scoped>
	/deep/.el-table,
	.el-table th,
	.el-table td {
		border-radius: 10px;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
		font-size: 16px;
		font-family: Times, "Times New Roman";
		/* font-weight: 600; */
	}

	.topNav {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff;
		padding: 20px 20px;
		border-radius: 10px;
	}

	.navFormWrapper {
		display: flex;
		align-items: center;
	}
</style>


// WEBPACK FOOTER //
// src/views/ruleEngine/customerRule.vue